import { NavbarCart } from "~/components/layout/navbar/NavbarCart";
import { NavbarConnectWalletPopover } from "../NavbarConnectWalletPopover";
import { NavbarLogo } from "../NavbarLogo";
import { NavbarMobilePopover } from "./NavbarMobilePopover";
import { NavbarMobileSearch } from "./NavbarMobileSearch";

export function NavbarMobile() {
  return (
    <>
      <NavbarLogo />

      <div className="ml-auto flex items-center space-x-6 pr-3 md:hidden">
        <NavbarMobileSearch />

        <NavbarCart />

        <NavbarMobilePopover />

        <NavbarConnectWalletPopover />
      </div>
    </>
  );
}
